import { useCallback, useEffect, useRef } from 'react';

export const useIntervalWithControlFunctions = (
  interval: number,
  actionToCall: () => void
) => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const start = useCallback(() => {
    intervalRef.current = setInterval(() => {
      actionToCall();
    }, interval);
  }, [interval, actionToCall]);

  const stop = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  }, []);

  return [start, stop];
};

export const useInterval = (callback: () => void, delay: number | null) => {
  const savedCallback = useRef<() => void | undefined>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => savedCallback.current && savedCallback.current();

    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};
